module.exports = __webpack_public_path__ + "static/r2c1-ea74320b3928e089ad5dad6c1f547f0a.png";